const TEMPLATE_PREVIEW_SAMPLE = `
    <h2>Template preview</h2>
    <p>This area shows how the email will look when it is sent.</p>
    <p><a class="button" href="#">Example action</a></p>
`;

export const buildTemplatePreviewHtml = (content = '', primaryColor = '#005EB8') => {
    const renderedContent = (content || TEMPLATE_PREVIEW_SAMPLE)
        .split('{email}')
        .join(TEMPLATE_PREVIEW_SAMPLE);

    if (/<!doctype|<html[\s>]/i.test(renderedContent)) {
        return renderedContent;
    }

    return `<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        * { box-sizing: border-box; }
        body { margin: 0; padding: 24px; background: #e8edee; color: #263238; font: 16px/1.6 Arial, sans-serif; }
        .email { max-width: 680px; margin: 0 auto; overflow: hidden; background: #fff; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,.12); }
        .header { padding: 22px 28px; background: ${primaryColor}; color: #fff; }
        .header h1 { margin: 0; font-size: 24px; }
        .content { padding: 32px 28px; }
        .footer { padding: 16px 28px; background: #f0f4f5; color: #425563; font-size: 12px; }
        .button { display: inline-block; padding: 11px 20px; border-radius: 4px; background: ${primaryColor}; color: #fff !important; text-decoration: none; font-weight: 600; }
        a { color: ${primaryColor}; }
    </style>
</head>
<body>
    <div class="email">
        <div class="header"><h1>OpenEP</h1></div>
        <div class="content">${renderedContent}</div>
        <div class="footer">OpenEP · Automated email preview</div>
    </div>
</body>
</html>`;
};
